/**
 * Created by Ning Jiang on 2021-05-21.
 */

import {ReelStopPresentationController} from "./ReelStopPresentationController";

export class ReelStopPresentationManager {

    private readonly _presentations:ReelStopPresentationController[];

    constructor(presentations:ReelStopPresentationController[]) {
        this._presentations = presentations.concat();
        if(this._presentations.length === 0) {
                this._presentations.push(new ReelStopPresentationController("default"));
        }
    }

    public async start():Promise<any> {
        await Promise.all(this._presentations.map(p => p.start()));
    }

    public skip():void {
        this._presentations.forEach(p => p.skip());
    }
}